import { Component, inject, signal } from "@angular/core";
import { ActivatedRoute, Router, RouterLink } from "@angular/router";
import { DomSanitizer, SafeHtml } from "@angular/platform-browser";
import { ROUTES } from "../../constants/routes";
import { Navbar } from "../../components/navbar/navbar";
import { Breadcrumb } from "../../components/breadcrumb/breadcrumb";
import { Footer } from "../../components/footer/footer";
import { SeoService } from "../../services/seo.service";
import { findSolution, SOLUTIONS, Solution } from "../../constants/solutions-data";
import { ICONS } from "../../constants/icons";
import {
  breadcrumbSchema,
  faqSchema,
  serviceSchema,
  webPageSchema
} from "../../helpers/structured-data";

@Component({
  selector: "app-industry",
  imports: [RouterLink, Breadcrumb, Navbar, Footer],
  templateUrl: "./industry.html",
  styleUrl: "./industry.scss"
})
export class Industry {
  readonly routes = ROUTES;
  private readonly route = inject(ActivatedRoute);
  private readonly router = inject(Router);
  private readonly seo = inject(SeoService);
  private readonly sanitizer = inject(DomSanitizer);

  readonly solution = signal<Solution | undefined>(undefined);
  readonly related = signal<Solution[]>([]);

  iconFor(name: string): SafeHtml {
    return this.sanitizer.bypassSecurityTrustHtml(ICONS[name] ?? "");
  }

  ngOnInit(): void {
    this.route.paramMap.subscribe(params => {
      const slug = params.get("industry") ?? "";
      const found = findSolution(slug);

      if (!found) {
        this.router.navigate([ROUTES.solutions.url]);
        return;
      }

      this.solution.set(found);
      this.related.set(SOLUTIONS.filter(item => item.slug !== found.slug).slice(0, 3));
      this.applySeo(found);
    });
  }

  private applySeo(solution: Solution): void {
    this.seo.apply({
      title: solution.metaTitle,
      description: solution.metaDescription,
      path: `/solutions/${solution.slug}`,
      keywords: solution.keywords,
      structuredData: [
        breadcrumbSchema([
          { name: "Home", path: "/" },
          { name: "Solutions", path: "/solutions" },
          { name: solution.name, path: `/solutions/${solution.slug}` }
        ]),
        webPageSchema({
          name: solution.metaTitle,
          description: solution.metaDescription,
          path: `/solutions/${solution.slug}`
        }),
        faqSchema(solution.faqs),
        serviceSchema()
      ]
    });
  }
}
